import React from 'react';
import { useDeviceDetection } from '../../hooks/useDeviceDetection';
import GestionView from './GestionView';
import GestionMovilView from './GestionMovilView';

/**
 * Vista automática que detecta el dispositivo y muestra
 * la versión apropiada de Gestión
 */
const GestionAutoView: React.FC = () => {
  const { isMobile, isTablet } = useDeviceDetection();

  const esMobileOTablet = isMobile || isTablet;

  if (esMobileOTablet) {
    return <GestionMovilView />;
  }

  return <GestionView />;
};

export default GestionAutoView;
